import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// @ts-expect-error - am-tax-fe-core module lacks TypeScript declarations
import feCoreEnglish from "am-tax-fe-core/locales/en/am-tax-fe-core.json";

export const initializeI18n = async (languageCode: string) => {
    await i18n
        // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
        // learn more: https://github.com/i18next/i18next-http-backend
        // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
        .use(ChainedBackend)
        // detect user language
        // learn more: https://github.com/i18next/i18next-browser-languageDetector
        .use(LanguageDetector)
        // pass the i18n instance to react-i18next.
        .use(initReactI18next)
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init({
            fallbackLng: "en",
            lng: languageCode,
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            backend: {
                backends: [
                    HttpBackend,
                    resourcesToBackend({
                        en: { "am-tax-fe-core": feCoreEnglish },
                    }),
                ],
                backendOptions: [
                    {
                        loadPath: "/locales/{{lng}}/{{ns}}.json",
                    },
                ],
            },
        });

    return i18n;
};
